import type { Audience, Tone, Channel } from '../types';

interface ContextSelectorsProps {
  audience: Audience;
  tone: Tone;
  channel: Channel;
  onAudienceChange: (a: Audience) => void;
  onToneChange: (t: Tone) => void;
  onChannelChange: (c: Channel) => void;
}

export function ContextSelectors({
  audience,
  tone,
  channel,
  onAudienceChange,
  onToneChange,
  onChannelChange,
}: ContextSelectorsProps) {
  return (
    <>
      <style>{`
        .context-grid {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          gap: 10px;
          margin-bottom: 16px;
        }
        @media (max-width: 500px) {
          .context-grid {
            grid-template-columns: 1fr 1fr 1fr;
          }
        }
        .context-select {
          width: 100%;
          padding: 9px 12px;
          border: 1px solid var(--border);
          border-radius: 10px;
          background: var(--bg-card);
          color: var(--text-primary);
          font-size: 13px;
          outline: none;
          cursor: pointer;
          transition: border-color 0.2s;
          font-family: 'Inter', system-ui, sans-serif;
          appearance: none;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-position: right 10px center;
          padding-right: 28px;
        }
        .context-select:focus {
          border-color: rgba(0,212,255,0.4);
        }
      `}</style>
      <div className="context-grid">
        {[
          { label: 'Audience', value: audience, onChange: onAudienceChange,
            options: [['executive','Executive'],['team','Team'],['stakeholder','Stakeholder']] },
          { label: 'Tone', value: tone, onChange: onToneChange,
            options: [['formal','Formal'],['neutral','Neutral'],['direct','Direct']] },
          { label: 'Channel', value: channel, onChange: onChannelChange,
            options: [['email','Email'],['slack','Slack'],['presentation','Deck']] },
        ].map(sel => (
          <div key={sel.label}>
            <label style={{
              display: 'block',
              fontSize: '11px',
              fontWeight: 600,
              color: 'var(--text-muted)',
              marginBottom: '5px',
              letterSpacing: '0.06em',
              textTransform: 'uppercase',
              fontFamily: "'Outfit', sans-serif",
            }}>
              {sel.label}
            </label>
            <select
              value={sel.value}
              onChange={e => sel.onChange(e.target.value as Audience & Tone & Channel)}
              className="context-select"
            >
              {sel.options.map(([v, l]) => (
                <option key={v} value={v}>{l}</option>
              ))}
            </select>
          </div>
        ))}
      </div>
    </>
  );
}
